import React, { useState, useEffect } from 'react';
import { templateAPI } from '../services/api';
import { toast } from 'react-toastify';
import '../styles/Templates.css';

function Templates() {
  const [templates, setTemplates] = useState([]);
  const [loading, setLoading] = useState(true);
  const [syncing, setSyncing] = useState(false);
  const [user, setUser] = useState(null);

  useEffect(() => {
    const userData = localStorage.getItem('user');
    if (userData) {
      setUser(JSON.parse(userData));
    }
    loadTemplates();
  }, []);

  const loadTemplates = async () => {
    setLoading(true);
    try {
      const response = await templateAPI.getAll();
      if (response.data.success) {
        setTemplates(response.data.data);
      }
    } catch (error) {
      toast.error('Không thể tải danh sách template');
    } finally {
      setLoading(false);
    }
  };

  const handleSyncFromZalo = async () => {
    if (!window.confirm('Đồng bộ templates từ Zalo OA? Quá trình này có thể mất vài giây.')) {
      return;
    }

    setSyncing(true);
    try {
      const response = await templateAPI.syncFromZalo();
      
      if (response.data.success) {
        const data = response.data.data;
        toast.success(
          `Đồng bộ thành công! Mới: ${data.new_synced}, Cập nhật: ${data.updated}`,
          { autoClose: 5000 }
        );
        
        // Reload templates
        await loadTemplates();
      }
    } catch (error) {
      const message = error.response?.data?.message || 'Lỗi khi đồng bộ từ Zalo';
      toast.error(message);
      console.error('Sync error:', error);
    } finally {
      setSyncing(false);
    }
  };

  const formatDate = (dateString) => {
    return new Date(dateString).toLocaleDateString('vi-VN', {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  if (loading) {
    return <div className="loading">Đang tải...</div>;
  }

  return (
    <div className="templates-container">
      <div className="page-header">
        <div>
          <h1>Quản lý Template ZNS</h1>
          <p>Danh sách các template đã được Zalo duyệt</p>
        </div>
        
        {user?.role === 'admin' && (
          <button 
            onClick={handleSyncFromZalo}
            className="btn-primary btn-sync"
            disabled={syncing}
          >
            {syncing ? (
              <>
                <span className="spinner"></span>
                Đang đồng bộ...
              </>
            ) : (
              <>
                🔄 Đồng bộ từ Zalo
              </>
            )}
          </button>
        )}
      </div>

      {templates.length === 0 ? (
        <div className="empty-state-card">
          <div className="empty-icon">📝</div>
          <h3>Chưa có template nào</h3>
          <p>Nhấn "Đồng bộ từ Zalo" để tải các template đã được duyệt từ Zalo OA</p>
          {user?.role === 'admin' && (
            <button onClick={handleSyncFromZalo} className="btn-primary" disabled={syncing}>
              🔄 Đồng bộ ngay
            </button>
          )}
        </div>
      ) : (
        <div className="templates-grid">
          {templates.map(template => (
            <div key={template.id} className="template-card">
              <div className="template-header">
                <h3>{template.template_name}</h3>
                <span className={`badge ${template.status}`}>
                  {template.status === 'active' ? 'Hoạt động' : 'Không hoạt động'}
                </span>
              </div>

              <div className="template-info-grid">
                <div className="info-row">
                  <span className="label">ID Template:</span>
                  <span className="value">{template.template_id}</span>
                </div>

                <div className="info-row">
                  <span className="label">Loại:</span>
                  <span className="value">{template.template_type}</span>
                </div>

                <div className="info-row">
                  <span className="label">Giá:</span>
                  <span className="value price">{template.price}đ/tin</span>
                </div>

                <div className="info-row">
                  <span className="label">Cập nhật:</span>
                  <span className="value">{formatDate(template.updated_at)}</span>
                </div>
              </div>

              <div className="template-params">
                <strong>Tham số:</strong>
                <div className="params-list">
                  {JSON.parse(template.parameters || '[]').map((param, idx) => (
                    <span key={idx} className="param-tag">
                      {param.name}
                    </span>
                  ))}
                  {JSON.parse(template.parameters || '[]').length === 0 && (
                    <span className="text-muted">Không có tham số</span>
                  )}
                </div>
              </div>

              <div className="template-content">
                <strong>Nội dung preview:</strong>
                <p>{template.content.substring(0, 150)}...</p>
              </div>

              <div className="template-actions">
                <a href={`/send-zns?template=${template.id}`} className="btn-secondary">
                  📤 Sử dụng template
                </a>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

export default Templates;
